import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/vsts/work/1/s/node_modules/next/dist/client/app-dir/link.js");
